import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Servicio de notificaciones
 * Usa MatSnackBar para mostrar errores al usuario
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar) { }

  /**
   * Muestra un mensaje de error al usuario con MatSnackBar
   * 
   * @param message Mensaje de error
   */
  showError(message: string): void {
    console.error('🚨 ERROR:', message);
    this.snackBar.open(message, 'Cerrar', { 
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['error-snackbar']
    });
  }

  /**
   * Muestra un mensaje de éxito al usuario
   * 
   * @param message Mensaje de éxito
   */
  showSuccess(message: string): void {
    console.log('✅ ÉXITO:', message);
    // TODO: Integrar con MatSnackBar cuando se requiera
    // this.snackBar.open(message, 'Cerrar', { duration: 3000, panelClass: ['success-snackbar'] });
  }

  /**
   * Muestra un mensaje informativo al usuario
   * 
   * @param message Mensaje informativo
   */
  showInfo(message: string): void {
    console.info('ℹ️ INFO:', message);
    // TODO: Integrar con MatSnackBar cuando se requiera
    // this.snackBar.open(message, 'Cerrar', { duration: 3000 });
  }

  /**
   * Muestra un mensaje de advertencia al usuario
   * 
   * @param message Mensaje de advertencia
   */
  showWarning(message: string): void {
    console.warn('⚠️ ADVERTENCIA:', message);
    // TODO: Integrar con MatSnackBar cuando se requiera
    // this.snackBar.open(message, 'Cerrar', { duration: 4000, panelClass: ['warning-snackbar'] });
  }
}
